import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalAddPersonalSpaceLink: ExperimentalMutations['experimentalAddPersonalSpaceLink'] =
	(_, { spaceUserKey }, { network: { cfetch } }) =>
		cfetch(`/wiki/rest/create-dialog/1.0/space-blueprint/create-personal-space?favorite=true`, {
			method: 'POST',
			body: JSON.stringify({
				spaceUserKey,
			}),
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then(
			/* onFulfilled */ () => true,
			// Handle case when User does not have permission to Create Space
			/* onRejected */ () => false,
		);
